
import React from 'react';
import { FacilityOrderTemplateNewFlowUSIntakeInsuranceQuestionModalTemplate } from 'themes/application/facility-order-new-flow-us-intake/components';
import { observer } from 'mobx-react';
import { setCurrentView } from 'core/utils';
import { FacilityOrderTemplateNewFlowUSIntakeInsuranceQuestionModalStore } from 'application/facility-order-new-flow-us-intake/stores';
@setCurrentView((rootStore, componentProps) => new FacilityOrderTemplateNewFlowUSIntakeInsuranceQuestionModalStore(rootStore, componentProps), 'facilityOrderTemplateNewFlowUSIntakeInsuranceQuestionModalStore')
@observer
class FacilityOrderTemplateNewFlowUSIntakeInsuranceQuestionModal extends React.Component {
    render() {
        return <FacilityOrderTemplateNewFlowUSIntakeInsuranceQuestionModalTemplate {...this.props} />
    }
}

export default FacilityOrderTemplateNewFlowUSIntakeInsuranceQuestionModal;
